const API_SPAM_TIMEOUT = 60 * 1000;

const API_SPAM_THRESHOLD = 100;

const SOCKET_SPAM_TIMEOUT = 60 * 1000;

const SOCKET_SPAM_THRESHOLD = 100;

export { API_SPAM_THRESHOLD, API_SPAM_TIMEOUT, SOCKET_SPAM_THRESHOLD, SOCKET_SPAM_TIMEOUT };
